type EnvironmentVariables = {
  apiBasePath: string;
  debounceDelayMS: number;
  enableTokenHookLogging: boolean;
  enableCasbinEnforcerLogging: boolean;
  environment: string;
  oktaClientId: string;
  oktaIssuer: string;
};

type RuntimeConfig = {
  API_BASE_PATH?: string;
  OKTA_CLIENT_ID?: string;
  OKTA_ISSUER?: string;
};

// env-config.js (loaded via a <script> tag in public/index.html) sets this before the app
// bundle runs, with values substituted by Octopus at deploy time. Locally / in Jest that file
// either isn't loaded or still contains unsubstituted "#{...}" tokens, so fall through to the
// build-time REACT_APP_* vars (today's local-dev behavior) and then to hardcoded defaults.
const runtimeConfig: RuntimeConfig = (window as any).__RUNTIME_CONFIG__ ?? {};

const fromRuntime = (value: string | undefined): string | undefined =>
  value && !value.startsWith('#{') ? value : undefined;

const environment: EnvironmentVariables = {
  apiBasePath: fromRuntime(runtimeConfig.API_BASE_PATH) || process.env.REACT_APP_API_BASE_PATH || 'https://localhost:6001/v2',
  debounceDelayMS: Number(process.env.REACT_APP_DEBOUNCE_DELAY_MS) || 0,
  enableTokenHookLogging: Boolean(process.env.REACT_APP_ENABLE_TOKEN_HOOK_LOGGING) || false,
  enableCasbinEnforcerLogging: Boolean(process.env.REACT_APP_ENABLE_CASBIN_ENFORCER_LOGGING) || false,
  environment: process.env.REACT_ENV || 'development',
  oktaClientId: fromRuntime(runtimeConfig.OKTA_CLIENT_ID) || process.env.REACT_APP_OKTA_CLIENT_ID || '',
  oktaIssuer: fromRuntime(runtimeConfig.OKTA_ISSUER) || process.env.REACT_APP_OKTA_ISSUER || ''
};

export default environment;
